import type { BatchEditSelectProps } from "./batch-edit-select.type";

import { Divider, Form, Select, Typography } from "antd";
import { useTranslation } from "react-i18next";

import { BatchEditSelectOption } from "./batch-edit-select-option";

import "./batch-edit-select.style.less";

const { Paragraph } = Typography;

const BatchEditSelect = <Value = string,>({
  type,
  subType,
  items,
  properties,
  onPropertyChange,
}: BatchEditSelectProps<Value>) => {
  const { t } = useTranslation();
  const count = items.length;

  let typeTranslateKey = `${type}:batchEditSelect`;
  if (subType) typeTranslateKey += `.${subType}`;

  return (
    <div className="batch-edit-select">
      <Paragraph>
        <strong>{count}</strong> {t(`${typeTranslateKey}.selected`, { count })}
        <br />
        {t("global:batchEditSelect.description")}
      </Paragraph>
      <Divider />
      <Form.Item layout="vertical" label={t("global:batchEditSelect.label")}>
        <Select
          placeholder={t("global:batchEditSelect.placeholder")}
          options={properties}
          optionRender={(option) => (
            <BatchEditSelectOption option={option.data} />
          )}
          onChange={onPropertyChange}
        />
      </Form.Item>
    </div>
  );
};

export default BatchEditSelect;
